import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Context } from 'context/context';
import segment from "segment";

import PasswordInput from 'components/PasswordInput';

import styles from 'entry/Entry.module.scss';

class CreateAccount extends Component {
    static contextType = Context;

    state = {
        processing: false,
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        firstNameValid: false,
        lastNameValid: false,
        passwordStrength: null,
        captcha: null,
    };

    turnstileRef = React.createRef();
    turnstileWidgetId = null;

    componentDidMount() {
        segment.page('Create Account');
        this.renderTurnstile();
    }

    componentWillUnmount() {
        if (window.turnstile && this.turnstileWidgetId !== null) {
            window.turnstile.remove(this.turnstileWidgetId);
        }
    }

    renderTurnstile = () => {
        if (window.turnstile && this.turnstileRef.current && this.turnstileWidgetId === null) {
            this.turnstileWidgetId = window.turnstile.render(this.turnstileRef.current, {
                sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
                callback: (token) => this.setCaptcha(token),
                'expired-callback': () => this.setCaptcha(null),
                'error-callback': () => this.setCaptcha(null),
            });
        } else if (this.turnstileWidgetId === null) {
            // Script not yet loaded — try again shortly
            setTimeout(this.renderTurnstile, 200);
        }
    };

    resetTurnstile = () => {
        if (window.turnstile && this.turnstileWidgetId !== null) {
            window.turnstile.reset(this.turnstileWidgetId);
        }
    };

    /**
     * Update State
     * @param {Object} event - onChange
     */
    updateState = (event) => {
        let firstNameValid = this.state.firstNameValid;
        let lastNameValid = this.state.lastNameValid;
        if(event.target.name === "firstName") {
            firstNameValid = /^[a-zÀ-ú'-]{2,}/i.test(event.target.value);
        } else if(event.target.name === "lastName") {
            lastNameValid = /^[a-zÀ-ú'-]{2,}/i.test(event.target.value);
        }
        this.setState({
            [event.target.name]: event.target.value,
            firstNameValid,
            lastNameValid
        })
    };

    /**
     * When password field is changed, update state
     * @param {object} event - onChange Event
     */
    updateStatePassword = (event) =>{
        this.setState({
            [event.target.name]: event.target.value,
            passwordStrength: event.target.strength
        })
    };

    setCaptcha = (value) => {
        this.setState({ captcha: value });
    }

    /**
     * Call context createAccount function and handles response (makes accountDetails)
     * @param {Object} event - onClick event
     */
    createAccount = async (event) => {
        this.setState({ processing: true });
        event.preventDefault();

        try {
            if(this.state.firstNameValid && this.state.lastNameValid) {
                if(this.state.passwordStrength >= 4) {
                    await this.context.createAccount(this.state.firstName, this.state.lastName, this.state.email, this.state.password, this.state.captcha);
                    await segment.track('account_created', {
                        application: 'dashboard'
                    });
                    window.location.href = "/verify-account";
                } else {
                    this.context.setToast('Please choose a stronger password. Try to include capitals, symbols and numbers., please try again.', 'Danger', 10000);
                }
            } else {
                this.context.setToast(!this.state.firstNameValid && !this.state.lastNameValid ? "First and last name are too short or invalid." : !this.state.lastNameValid ? "Last name is too short or invalid." :  "First name is too short or invalid.", "Danger", 10000);
            }
        } catch {
            this.setCaptcha(null);
            this.resetTurnstile();
        } finally {
            this.setState({
                processing: false,
            })
        }
    };

    render() {
        return (
            <>
                <div className={`bgSecondary ${styles.action}`}>
                    <NavLink to="/log-in" className="btn btnBrand">Log In</NavLink>
                </div>
                <div className={`bgSecondary ${styles.login}`}>
                    <form onSubmit={this.createAccount}>
                        <h1>Create Account</h1>
                        <div className={styles.names}>
                            <input 
                                type="text" 
                                name="firstName" 
                                placeholder="First Name" 
                                value={this.state.firstName} 
                                onChange={this.updateState}
                            />
                            <input 
                                type="text" 
                                name="lastName" 
                                placeholder="Last Name" 
                                value={this.state.lastName} 
                                onChange={this.updateState}
                            />
                        </div>
                        <input 
                            type="email" 
                            name="email" 
                            placeholder="Email Address" 
                            value={this.state.email} 
                            onChange={this.updateState}
                        />
                        <PasswordInput 
                            autoComplete={false} 
                            name="password" 
                            placeholder="Choose Password" 
                            value={this.state.password} 
                            onChange={this.updateStatePassword}
                        />
                        <div ref={this.turnstileRef} />
                        <p className={styles.policy}>
                            By creating an account you agree to adhere to our 
                            <a href="https://speedweaver.co.uk/fair-usage-policy" target="_blank">
                                Fair Usage Policy
                            </a>.
                        </p>
                        <input 
                            disabled={this.state.processing || !this.state.captcha} 
                            type="submit" value={"Create Account"} 
                            className={"btn btnBrand"}
                        />
                    </form>
                </div>
            </>
        )
    }
}

export default CreateAccount;
